import { MemberAccountPreferenceKey } from 'client/features/member-account/types';
import { UpdateDigestPreferenceParams } from 'client/features/member-account/use-cases/update-digest-notification-preference';
import { UpdateNotificationPreferenceParams } from 'client/features/member-account/use-cases/update-notification-preference';
import { DataSource } from '@client/core/data/concerns/data-source';
import { fromJson, JsonResponse } from '@client/core/data/concerns/parses-from-json';
import { HttpResponse } from '@client/core/http/types';
import { MemberAccountPreference } from '@client/features/member-account/models/member-account-preference';

export class MemberAccountDataSource extends DataSource {
  async getMemberAccountPreferenceByKey<T = any>(
    ownerId: number,
    key: MemberAccountPreferenceKey,
  ): Promise<MemberAccountPreference<T>> {
    const response = await this.httpClient.get<HttpResponse<JsonResponse>>(
      `/workspace/${ownerId}/member-account-preferences`,
      {
        params: {
          key,
        },
      },
    );

    return fromJson(MemberAccountPreference<T>, response.data.data);
  }

  async updateNotificationPreference(params: UpdateNotificationPreferenceParams): Promise<void> {
    await this.httpClient.patch<HttpResponse<JsonResponse>>(
      `/workspace/${params.ownerId}/member-account-preferences/notifications`,
      {
        type: params.type,
        channel: params.channel,
        value: params.value,
      },
    );
  }

  async updateDigestPreference(params: UpdateDigestPreferenceParams): Promise<void> {
    await this.httpClient.patch<HttpResponse<JsonResponse>>(
      `/workspace/${params.ownerId}/member-account-preferences/digest`,
      params.preferences,
    );
  }
}
